module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "بولا-بولس-ربيز-شاعرة-الياسمين"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بولا بولس ربيز (شاعرة الياسمين)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وُلدَت بولا ربيز (شاعرة الياسمين) في لبنان \"رأس بيروت\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ودرسَتِ العلوم السياسيَّة في الجامعة الأمريكية في بيروت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حصلَت لاحقًا على درجة الماجستير في الشؤون الدولية والدراسات الإستراتيجيَّة العسكرية مِن جامعة كينجز كولدج - لندن في بريطانيا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تعيش حاليًّا في الإمارات العربية المتحدة، وتمتلك شركة تجارية.. هي مجازة مِن مدينة دبي للإعلام كصحافية وكاتبة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اشتُهرَت منذ الصِّغر بحبِّها الشديد للشعر والنثر")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قرأتِ الدواوين مِن شعراء الجاهليَّة حتَّى العصر الحديث أبدعَت بعشقها للغة العربية وتعلُّقها بكلِّ حرف وكلمة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تُعدُّ رحلة الكتابة فرصة للتعبير عن أفكارها ومشاعرها ومشاركة عالمها الداخلي مع الآخَرين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تتطلَّع إلى أن تلهِم القُرَّاء بأفكارها وتجاربها وتسعى لتعزيز دور المرأة في المجتمع.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-254a15be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 63
// module chunks = 0